import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=b6888c34&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=b6888c34&prod&lang=scss&scoped=true&"
import style1 from "./PatientList.vue?vue&type=style&index=1&id=b6888c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6888c34",
  null
  
)

export default component.exports